import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { CheckCircle2 } from "lucide-react";
import Logo from "@/components/Logo";

export default function EmailConfirmation() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="space-y-1 flex flex-col items-center">
          <Logo className="mb-4 text-2xl" />
          <CardTitle className="text-2xl font-bold text-center">
            ¡Email verificado!
          </CardTitle>
          <CardDescription className="text-center text-base">
            Tu correo electrónico ha sido verificado exitosamente.
            <br />
            Ahora puedes iniciar sesión y disfrutar de todos los servicios de la
            plataforma.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center justify-center space-y-4">
          <CheckCircle2 className="h-16 w-16 text-green-500 mb-2" />
        </CardContent>
        <CardFooter className="flex flex-col space-y-4">
          <Button className="w-full" onClick={() => navigate("/login")}>
            Ir a Inicio de Sesión
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
